<template>
  <footer class="app-footer">
  	<div>© 2018 xpressbees.</div>
  </footer>
</template>
<script>
export default {
  name: 'footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue?ef29aa02